import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';

import { AlertState } from '../notification.models';

@Injectable()
export class NotificationAction {
    static ADD_ALERT = '[Notification]: Add alert';
    static REMOVE_ALERT = '[Notification]: Remove alert';
    static REMOVE_ALL_ALERTS = '[Notification]: Remove all alerts';
    // NavigationEnd: Clear showAfterRouteChange flags so alerts display
    static readonly CLEAR_ROUTE_CHANGE_FLAGS = '[Notification]: Clear route change flags';
    // NavigationStart: Filter to keep only alerts marked for next route
    static readonly FILTER_NEXT_PAGE_ALERTS = '[Notification]: Filter alerts for next page';

    addAlert(alert: AlertState): RidangoReduxAction {
        return {
            type: NotificationAction.ADD_ALERT,
            payload: alert
        };
    }

    removeAlert(alert: AlertState): RidangoReduxAction {
        return {
            type: NotificationAction.REMOVE_ALERT,
            payload: alert
        };
    }

    removeAll(): RidangoReduxAction {
        return {
            type: NotificationAction.REMOVE_ALL_ALERTS
        };
    }

    // Called on NavigationEnd - clears flags so alerts can display
    clearRouteChangeFlags(): RidangoReduxAction {
        return {
            type: NotificationAction.CLEAR_ROUTE_CHANGE_FLAGS
        };
    }

    // Called on NavigationStart - keeps only alerts marked to show after route change
    filterNextPageAlerts(): RidangoReduxAction {
        return {
            type: NotificationAction.FILTER_NEXT_PAGE_ALERTS
        };
    }
}
